import type {
  BusinessConfig,
} from "@/lib/business-config";
import { getStorefrontUrl } from "@/lib/storefront-url";
import type { Company } from "@/types/company";
import type { Product } from "@/types/product";

export function getPublicItemPath(
  businessConfig: BusinessConfig,
  product: Pick<Product, "slug" | "item_kind">,
): string {
  return (
    `/${product.item_kind === "product" && businessConfig.businessType === "services" ? "produto" : businessConfig.publicItemPath}/${encodeURIComponent(
      product.slug,
    )}`
  );
}

export function getPublicItemUrl(
  company: Company,
  businessConfig: BusinessConfig,
  product: Pick<Product, "slug" | "item_kind">,
): string {
  const storefrontUrl =
    getStorefrontUrl(company).replace(
      /\/$/,
      "",
    );

  return (
    `${storefrontUrl}${getPublicItemPath(
      businessConfig,
      product,
    )}`
  );
}

export function getPublicItemArtworkUrl(
  company: Company,
  businessConfig: BusinessConfig,
  product: Pick<Product, "slug" | "item_kind">,
): string {
  return (
    `${getPublicItemUrl(
      company,
      businessConfig,
      product,
    )}/arte`
  );
}
